import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Select,
  Form,
  DatePicker,
  Col,
  Divider,
  Button,
  Spin,
  Transfer,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { LeftOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../configurations/configurations.config";
import CustomButton from "../../../components/custom/CustomButton";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Text, Title } = Typography;

const NewHoliday = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [rescheduleTypeData, setRescheduleTypeData] = useState([]);
  const [officesOptions, setOfficesOptions] = useState([]);
  const [selectedOffices, setSelectedOffices] = useState([]);
  const [office, setOffice] = useState([]);
  const [isSpecifiedDate, setIsSpecifiedDate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);

  useEffect(() => {
    getTemplate();
    getOffices();
  }, []);

  function getTemplate() {
    const url = `${apiConfig.Holidays}/template`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            value: element?.id,
            label: element?.value,
          });

          setRescheduleTypeData(tempArray);
        });
      }
    });
    setIsLoading(false);
  }

  function getOffices() {
    const url = `${apiConfig.Offices}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        const tempOfficesOptions = [];

        objList?.forEach((element) => {
          tempOfficesOptions.push({
            key: element.id,
            value: element.id,
            label: element.name,
            parentId: element?.parentId ? element?.parentId : "-",
            isParent: element.name === "Head Office" ? true : false,
            isChildWithDescendant: element.name === "TEST OFFICE 2" ? true : false,
          });
        });

        console.log(tempOfficesOptions);
        setOfficesOptions(tempOfficesOptions);
      }
    });
    setIsLoading(false);
  }

  function onCancel() {
    navigate("/manage-holidays", { state: state });
  }

  const renderItem = (item) => {
    return {
      label: item.label,
      value: item.value,
    };
  };

  const handleChange = (newTargetKeys, direction, moveKeys) => {
    let tempOfficesObj = [];

    officesOptions.forEach((element) =>
      tempOfficesObj.push({
        officeId: element.value,
      })
    );
    const officesObj = moveKeys.map((key, index) =>
      tempOfficesObj.find((item) => item.officeId === key)
    );
    setOffice(officesObj);
    setSelectedOffices(newTargetKeys);
    // setTargetKeys(newTargetKeys);
    // setSelectedKeys([]); // Clear selections after transfer
  };

  const onSubmit = (formValues) => {
    let tempOfficesObj = [];

    formValues.repaymentsRescheduledTo = formValues.repaymentsRescheduledTo
      ? BOM.DateTime(formValues.repaymentsRescheduledTo, "only-date")
      : formValues.repaymentsRescheduledTo;
    formValues.fromDate = formValues.fromDate
      ? BOM.DateTime(formValues.fromDate, "only-date")
      : formValues.fromDate;
    formValues.toDate = formValues.toDate
      ? BOM.DateTime(formValues.toDate, "only-date")
      : formValues.toDate;

    selectedOffices.forEach((element) =>
      tempOfficesObj.push({
        officeId: element,
      })
    );

    formValues.offices = tempOfficesObj;

    const url = `${apiConfig.Holidays}`;

    const body = {
      ...formValues,
      method: "POST",
      session,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
    };

    setIsLoading(true);

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newHolidayMsg);
          navigate("/manage-holidays", { state: state });

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/manage-holidays", { state: state });
          setIsLoading(false);
        },
      }
    );
  };

  const handleRepaymentSchedulingTypeChange = (valueParam) => {
    if (valueParam === 2) {
      setIsSpecifiedDate(true);
    } else {
      setIsSpecifiedDate(false);
    }
  };

  // Handle selection changes
  const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    const newSelectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];

    // Logic to auto-select descendants based on selection
    const updatedSelectedKeys = newSelectedKeys.reduce((acc, key) => {
      const item = officesOptions.find((d) => d.key === key);
      if (item) {
        if (item.isParent) {
          // If Head Office is selected, select all children and grandchildren
          const childKeys = officesOptions.filter((d) => d.parentId === key).map((d) => d.key);
          const grandChildKeys = officesOptions
            .filter((d) => d.parentId === 6) // TRAINING BRANCH 01 under TEST OFFICE 2
            .map((d) => d.key);
          return [...acc, key, ...childKeys, ...grandChildKeys];
        } else if (item.isChildWithDescendant && key === 6) {
          // If TEST OFFICE 2 is selected, select only itself and TRAINING BRANCH 01
          const grandChildKey = officesOptions.filter((d) => d.parentId === key).map((d) => d.key);
          return [...acc, key, ...grandChildKey];
        }
      }
      return [...acc, key]; // For standalone selections (e.g., FCMB, TEST OFFICE 1, TRAINING BRANCH 01)
    }, []);

    setSelectedOffices([...new Set(updatedSelectedKeys)]);
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.newHoliday}
        pageItems={staticConfig.newHolidayBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Row>
              {/* DETAILS  */}

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.name}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.name),
                    },
                  ]}
                >
                  <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.name)} />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.fromDate}
                  name="fromDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.fromDate),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={BOM.DisableBeforeCurrentDate}
                    placeholder={BOM.handlePlaceholderMsg(`${labelConfig.fromDate}`, "select")}
                    style={{
                      width: "100%",
                      height: 35,
                    }}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.toDate}
                  name="toDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.toDate),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={BOM.DisableBeforeCurrentDate}
                    placeholder={BOM.handlePlaceholderMsg(`${labelConfig.toDate}`, "select")}
                    style={{
                      width: "100%",
                      height: 35,
                    }}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.repaymentSchedulingType}
                  name="reschedulingType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.repaymentSchedulingType),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.repaymentSchedulingType,
                      "select"
                    )}
                    options={rescheduleTypeData}
                    onChange={handleRepaymentSchedulingTypeChange}
                    showSearch
                  />
                </Form.Item>
              </Col>

              {isSpecifiedDate && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.repaymentScheduledTo}
                    name="repaymentsRescheduledTo"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.repaymentScheduledTo),
                      },
                    ]}
                  >
                    <DatePicker
                      disabledDate={(current) => {
                        const fromDate = useForm.getFieldValue("fromDate");

                        // Get the minimum allowed date (max of today or fromDate)
                        const minDate = fromDate
                          ? dayjs(fromDate).startOf("day")
                          : dayjs().startOf("day");

                        return current && current.isBefore(minDate, "day");
                      }}
                      placeholder={BOM.handlePlaceholderMsg(
                        `${labelConfig.repaymentScheduledTo}`,
                        "select"
                      )}
                      style={{ width: "100%", height: 35 }}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>

            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.description} name="description">
                  <TextArea
                    placeholder={BOM.handlePlaceholderMsg(`${labelConfig.description}`, "select")}
                    style={{
                      width: "100%",
                      height: 70,
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider orientation="left" orientationMargin="0">
                {labelConfig.applicableOffices}
              </Divider>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Transfer
                  titles={[labelConfig.applicableOffices, labelConfig.selectedOffices]}
                  dataSource={officesOptions}
                  listStyle={{ width: 400 }}
                  targetKeys={selectedOffices}
                  onChange={handleChange}
                  render={renderItem}
                  rowKey={(record) => record.value}
                  onSelectChange={handleSelectChange}
                />
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("CREATE_HOLIDAY") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default NewHoliday;
